/**
 * Every cache key in one place.
 *
 * Two call sites spelling a key slightly differently is two caches for one
 * fact, and the bug it produces — a run sheet that does not refresh after the
 * job on it changed — is the hardest kind to see from a pavement.
 */
export const queryKeys = {
  me: ['me'] as const,
  riderProfile: ['rider-profile'] as const,
  cashBalance: ['rider-cash-balance'] as const,

  /** Everything still in motion. The run sheet. */
  runSheet: ['deliveries', 'active'] as const,
  /** What has finished, delivered and not delivered together. */
  history: ['deliveries', 'history'] as const,
  delivery: (deliveryId: string) => ['delivery', deliveryId] as const,
};
